"use client";

import React from "react";
import { Menu, Search, Bell, Sparkles } from "lucide-react";
import { Breadcrumb } from "./breadcrumb";
import { ProfileMenu } from "../user/profile-menu";
import { Button } from "../ui/button";

interface TopBarProps {
  onOpenMobileSidebar: () => void;
}

export function TopBar({ onOpenMobileSidebar }: TopBarProps) {
  return (
    <header className="flex h-14 items-center justify-between border-b border-border bg-card px-6 text-foreground select-none shrink-0 sticky top-0 z-30">
      {/* Left section: mobile toggle and breadcrumbs */}
      <div className="flex items-center gap-4">
        <button
          onClick={onOpenMobileSidebar}
          className="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-card-muted md:hidden outline-none cursor-pointer border border-border/50"
          aria-label="Open navigation menu"
        >
          <Menu className="h-4 w-4" />
        </button>
        <div className="hidden sm:block">
          <Breadcrumb />
        </div>
      </div>

      {/* Right section: global actions & profile menu */}
      <div className="flex items-center gap-4">
        {/* Mock Search Bar */}
        <div
          onClick={() =>
            window.dispatchEvent(new CustomEvent("toggle-command-palette"))
          }
          className="relative hidden md:block w-64 cursor-pointer select-none"
        >
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-text-muted" />
          <input
            type="button"
            value="Cerca o digita Ctrl+K..."
            className="h-9 w-full rounded-lg border border-border bg-card-muted pl-9 pr-3 text-xs text-left text-text-muted outline-none cursor-pointer hover:bg-card-muted/80 transition-colors"
          />
        </div>

        {/* Quick create node button */}
        <Button
          variant="outline"
          size="sm"
          className="hidden sm:flex gap-1.5 h-8"
        >
          <Sparkles className="h-3.5 w-3.5 text-primary-500 animate-pulse" />
          <span>Crea Nodo</span>
        </Button>

        {/* Notifications Icon */}
        <button className="relative flex h-8 w-8 items-center justify-center rounded-lg hover:bg-card-muted text-text-secondary outline-none cursor-pointer border border-border/50">
          <Bell className="h-4 w-4" />
          <span className="absolute right-2 top-2 h-1.5 w-1.5 rounded-full bg-error" />
        </button>

        {/* Profile menu dropdown */}
        <ProfileMenu />
      </div>
    </header>
  );
}
